export const LANGUAGES = ['en', 'es', 'pt', 'it', 'cz'];